export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "search.worker-ef5ae2cceb7ccab3f5e2.worker.js");
}
